import React from "react";

export default function Feature() {
  return (
    <div className="container mt-20">
      <div className="grid-rows-1">
        <div className="columns-3 flex items-center">
          <div className="text-center p-5">
            <img
              src={require("../../images/testi-1.png")}
              alt="Gambar 1"
              className="w-56 mx-auto"
            />
            <h5 className="font-bold text-xl text-green-700">Leaf</h5>
            <p className="text-xs">
            Lorem ipsum dolor sit amet consectetur adipisicing elit.
            Repudiandae impedit voluptatum sapiente possimus odit officia
            libero quaerat eaque a quos!
            </p>
          </div>

          <div className="text-center p-5">
            <img
              src={require("../../images/testi-2.png")}
              alt="Gambar 2"
              className="w-56 mx-auto"
            />
            <h5 className="font-bold text-xl text-green-700">Tree</h5>
            <p className="text-xs">
            Lorem ipsum dolor sit amet consectetur adipisicing elit.
            Repudiandae impedit voluptatum sapiente possimus odit officia
            libero quaerat eaque a quos!
            </p>
          </div>

          <div className="text-center p-5">
            <img
              src={require("../../images/testi-3.png")}
              alt="Gambar 3"
              className="w-56 mx-auto"
            />
            <h5 className="font-bold text-xl text-green-700">Recycle</h5>
            <p className="text-xs">
            Lorem ipsum dolor sit amet consectetur adipisicing elit.
            Repudiandae impedit voluptatum sapiente possimus odit officia
            libero quaerat eaque a quos!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
